import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import axios from 'axios';
// import { Grid } from 'gridjs-react';
// import { DataGrid } from '@mui/x-data-grid';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Form from 'react-bootstrap/Form';
// import Link from '@mui/material/Link';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import { DatatableWrapper, Filter, TableBody, TableHeader } from 'react-bs-datatable';
import { Table } from 'react-bootstrap';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { fetchToken } from '../components/Auth';
import { getUnits } from '../components/ApiAccess';
// import { useGetApi } from '../components/ApiAccess';
import { getSelfClient } from '../components/ApiAccess';
import { ClientName } from '../components/ApiAccess';
import CustomPagination from '../components/Pagination';

import Spinner from 'react-bootstrap/Spinner';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQrcode,
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';
import {
  faTrashAlt,
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-regular-svg-icons';

/**
 * 施策登録Button
 * @param {*} param0
 * @returns
 */
const UnitCreateBtn = ({ clientId, mode }) => {
  const navigate = useNavigate();

  /**
   * ボタンのイベントハンドラ
   * @param {*} event
   */
  const handleCreateUnit = (event) => {
    if (mode) {
      navigate('/self/new');
    } else {
      navigate('/clients/' + clientId + '/units/new');
    }
  };

  return (
    <>
      <Button
        variant="dark"
        size="sm"
        onClick={(event) => {
          handleCreateUnit(event);
        }}
      >
        施策登録
      </Button>
    </>
  );
};

/**
 * 表の中に表示される施策集計画面へ遷移するボタン
 * @param {*} param0
 * @returns
 */
const AccessLogBtn = ({ row }) => {
  const navigate = useNavigate();

  /**
   * ボタンのイベントハンドラ
   * @param {*} event
   * @param {*} cellValues
   */
  const handleShowAccessLog = (event, cellValues) => {
    navigate('./' + cellValues.row.id);
  };

  return (
    <>
      <Button
        variant="link"
        size="sm"
        className="text-start accesslog-btn"
        onClick={(event) => {
          handleShowAccessLog(event, { row: row });
        }}
      >
        {row.name}
      </Button>
    </>
  );
};

/**
 * 表の中に表示されるCSVダウンロードボタン
 * @param {*} param0
 * @returns
 */
const CsvFileDownloadBtn = ({ row, disabled }) => {
  /**
   * ボタンのイベントハンドラ
   * @param {*} event
   * @param {*} cellValues
   */
  const handleCSVFileDownload = (event, cellValues) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    let filename;

    axios
      .get('/api/v1/units/' + cellValues.row.id + '/items/?csv=true', {
        headers: headers,
        responseType: 'blob',
      })
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        else filename = filename.replace(/['"]/g, '');
        return response.data;
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      })
      .catch((error) => {});
  };

  return (
    <>
      <Button
        variant="dark"
        size="sm"
        onClick={(event) => {
          handleCSVFileDownload(event, { row: row });
        }}
        disabled={disabled}
      >
        CSV出力
      </Button>
    </>
  );
};

/**
 * 表の中に表示されるQRコードダウンロードボタン
 * @param {*} param0
 * @returns
 */
const QRCodeDownloadBtn = ({ row, disabled }) => {
  /**
   * ボタンのイベントハンドラ
   * @param {*} event
   * @param {*} cellValues
   */
  const handleQRCodeDownload = (event, cellValues) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    let filename;

    axios
      .get('/api/v1/units/' + cellValues.row.id + '/items/?img=true', {
        headers: headers,
        responseType: 'blob',
      })
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        else filename = filename.replace(/['"]/g, '');
        return response.data;
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      })
      .catch((error) => {});
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="custom-tooltip" {...props}>
      QRサンプル出力：QRコードの出力をお試しいただけます。（※上限20件）
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
        <Button
          variant="outline-dark"
          size="sm"
          onClick={(event) => {
            handleQRCodeDownload(event, { row: row });
          }}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faQrcode} /> QR出力
        </Button>
      </OverlayTrigger>
    </>
  );
};

const ShowEditUnitBtn = ({ row }) => {
  const navigate = useNavigate();
  /**
   * ボタンのイベントハンドラ
   * @param {*} event
   * @param {*} cellValues
   */
  const handleShowEditUnit = (event, cellValues) => {
    navigate('./' + cellValues.row.id + '/edit');
  };

  return (
    <>
      <Button
        variant="dark"
        size="sm"
        onClick={(event) => {
          handleShowEditUnit(event, { row: row });
        }}
      >
        施策編集
      </Button>
    </>
  );
};

const DeleteUnitBtn = ({ onDeleteBtnClick, disabled }) => {
  const handleBtnClick = (event) => {
    onDeleteBtnClick(event);
  };

  return (
    <>
      <Button
        variant="outline-danger"
        size="sm"
        onClick={(event) => {
          handleBtnClick(event);
        }}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Button>
    </>
  );
};

/**
 * 削除確認用モーダルダイアログ
 * @param {*} param0
 * @returns
 */
const DeleteConfirmModal = ({ show, setShow, apply, showData }) => {
  /**
   * 閉じるイベントハンドラ
   */
  const handleClose = () => {
    setShow(false);
  };

  /**
   * 削除操作を適用するボタンのイベントハンドラ
   */
  const handleApply = () => {
    setShow(false);
    apply();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>施策を削除しますか？</Modal.Title>
        </Modal.Header>
        <Modal.Body>施策名：{showData.data && showData.data.name}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleApply}>
            削除する
          </Button>
        </Modal.Footer>
      </Modal>{' '}
    </>
  );
};

const Functions4Unit = ({ row, onDeleteBtnClick }) => {
  const [status, setStatus] = useState(row.status);

  useEffect(() => {
    setStatus(row.status);

    return fetchProcess();
  }, [row]);

  let intervalId;

  const fetchProcess = () => {
    const fetchFileStatus = async () => {
      clearInterval(intervalId);

      if (!(row.status === 'ENTRY' || row.status === 'REGISTERING')) {
        return;
      }

      const response = loadFileStatus(row.id).then((response) => {
        const file_data = response.data[0] || {};
    
        setStatus(file_data.status);

        if (file_data.status === 'ENTRY' || file_data.status === 'REGISTERING') {
          intervalId = setInterval(() => {
            fetchFileStatus();
          }, 5000);
        }
      });
    };
    intervalId = setInterval(() => {
      fetchFileStatus();
    }, 100);

    return () => clearInterval(intervalId);
  };

  const loadFileStatus = (unitId) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const response = axios
      .get('/api/v1/units/' + unitId + '/files/?limit=1', { headers: headers })
      .then((response) => response)
      .catch((error) => {
        return Promise.reject(error);
      });
    return response;
  };

  return (
    <>
  <span className="unit-functions-row">
        <span className="file-status">
          {status === 'init' ? (
            <>
              <Spinner animation="grow" size="sm" />
            </>
          ) : (
            <>
              {status === 'COMPLETED' || status === 'ACCEPT' || status === 'REJECT' ? (
                <>
                  <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                </>
              ) : (
                <>
                  {status === 'REGISTERING' ? (
                    <>
                      <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning" />
                    </>
                  ) : (
                    <>
                      {status === 'ABORT' ? (
                        <>
                          <FontAwesomeIcon icon={faTimesCircle} className="text-danger" />
                        </>
                      ) : (
                        <>
                          {status === 'ENTRY' ? (
                            <>
                              <Spinner animation="border" size="sm" />
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </span>
  <span className="unit-functions-btns">
          <ShowEditUnitBtn row={row}></ShowEditUnitBtn>
          <CsvFileDownloadBtn row={row} disabled={status === 'ENTRY'}></CsvFileDownloadBtn>
          <QRCodeDownloadBtn row={row} disabled={status === 'ENTRY'}></QRCodeDownloadBtn>
        </span>
        <span>
          <DeleteUnitBtn
            onDeleteBtnClick={onDeleteBtnClick}
            disabled={status === 'ENTRY'}
          ></DeleteUnitBtn>
        </span>
      </span>
    </>
  );
};

/**
 * 施策一覧表示テーブル
 * @param {*} param0
 * @returns
 */
const UnitsListTbl = ({ clientId, deleteData, mode }) => {
  const [data, setData] = useState([]);
  const [reflesh, setReflesh] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(null);
  const navigate = useNavigate();

  const limit = 100;
  const skip = limit * (currentPage - 1);

  useEffect(() => {
    getUnits(clientId, skip, limit).then((response) => {
      if (response.status === 200) {
        const files = response.files.map((file) => {
          file.created_date = new Date(file.created_at).toLocaleDateString();
          return file;
        });

        const data = response.data.map((row) => {
          row.created_date = new Date(row.created_at).toLocaleDateString();
          row.status = files.filter((file) => file.unit_id === row.id)[0]?.status ?? 'init';
          return row;
        });
        setData(data);

        const newPageTotal = Math.ceil(response.count / limit);
        setPageTotal(newPageTotal);
      }
    });
  }, [reflesh, clientId, currentPage]);

  /**
   * テーブルの中の削除ボタンのイベントハンドラ
   * @param {*} event
   * @param {*} cellValues
   */
  const handleDeleteUnit = (event, cellValues) => {

    deleteData({ data: cellValues.row, callbackApply: handleDeleteApply });
  };

  /**
   * 削除を適用する
   * @param {*} deleteData
   */
  const handleDeleteApply = (deleteData) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    axios
      .delete('/api/v1/units/' + deleteData.id + '/', { headers: headers })
      .then((response) => {
        setReflesh(new Date());
      })
      .catch((error) => {});
  };

  /**
   * テーブルの列定義
   */
  const columns = [
    {
      prop: 'name',
      title: '施策名',
      isFilterable: true,
      width: 400,
      cell: (row) => (
        <>
          <AccessLogBtn row={row}></AccessLogBtn>
        </>
      ),
    },
    { prop: 'created_date', title: '登録日' },
    {
      prop: 'functions',
      title: '',
      sortable: false,
      width: 100,
      cell: (row) => (
        <>
          <Functions4Unit
            row={row}
            onDeleteBtnClick={(event) => {
              handleDeleteUnit(event, { row: row });
            }}
          ></Functions4Unit>
        </>
      ),
    },
  ];

  return (
    <>
      <DatatableWrapper headers={columns} body={data}>
        <div className="mb-3">
          <Filter placeholder="施策名検索" />
        </div>

        <Form.Group className="mb-3 d-flex justify-content-end">
          <UnitCreateBtn clientId={clientId} mode={mode}></UnitCreateBtn>
        </Form.Group>
  <div className="my-3 unitslist-table-scroll">
          <Table>
            <TableHeader />
            <TableBody />
          </Table>
        </div>
      </DatatableWrapper>
      <CustomPagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageTotal={pageTotal}
      ></CustomPagination>
    </>
  );
};

/**
 * 施策一覧画面
 * @param {*} param0
 * @returns
 */
export default function UnitsList({ mode }) {
  // const navigate = useNavigate();
  const params = useParams();

  const [clientId, setClientId] = useState();

  const [showModal, setShowModal] = useState(false);

  const [selectData, setSelectData] = useState({});

  useEffect(() => {
    if (!clientId) {
      if (params.clientId) {
        setClientId(params.clientId);
      } else {
        getSelfClient().then((response) => {
          setClientId(response.data.id);
        });
      }
    }
  }, [params.clientId, clientId]);

  /**
   * 施策一覧テーブル内の削除ボタンのイベントからコールバックされる
   * @param {*} target
   */
  const handleDeleteUnit = (target) => {

    setSelectData(target);
    setShowModal(true);
  };

  /**
   * 削除確認のモーダルからコールバックされる
   * @param {*} event
   */
  const handleApplyDelete = (event) => {
    // setShowModal(false);

    selectData.callbackApply(selectData.data);
  };

  return (
    <div className="unitslist">
      <Header></Header>
      <main>
        {clientId ? (
          <>
            <Container>
              <h2 className="unitslist-title">
                <ClientName clientId={clientId} />
              </h2>

              <div className="unitslist-title-wrapper">
                <h3 className="unitslist-title-text">施策一覧</h3>
              </div>

              <div className="unitslist-table-wrapper">
                <UnitsListTbl
                  clientId={clientId}
                  deleteData={handleDeleteUnit}
                  mode={mode}
                ></UnitsListTbl>
              </div>
            </Container>
          </>
        ) : (
          <></>
        )}
      </main>

      <DeleteConfirmModal
        show={showModal}
        setShow={setShowModal}
        apply={handleApplyDelete}
        showData={selectData}
      ></DeleteConfirmModal>

      <Footer />
    </div>
  );
}
